module.exports = __webpack_public_path__ + "img/tech-driven-solution.c4f7b7ee.png";